import _ttmlFunc from "../functions/profiles/ttmlGeneral.js";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _alignments from "../dict/alignments.js";
import _convertStylestoStyleMap from "../functions/special/convertStylestoStyleMap.js";
import _convertRegionsToPositionMap from "../functions/special/convertRegionsToPositionMap.js";
import _flexbox from "../dict/flexbox.js";
import { XMLParser as _XMLParser } from "fast-xml-parser";
import _JsonFind from "json-find";
import _eol from "eol";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const convertToHtml = _convertToHtml;
const eol = _eol;
const JsonFind = _JsonFind;
const XMLParser = _XMLParser; //Decode
const flexbox = _flexbox;
const convertRegionsToPositionMap = _convertRegionsToPositionMap;
const convertStylestoStyleMap = _convertStylestoStyleMap;
const alignments = _alignments;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const ttmlFunc = _ttmlFunc;
export default {
  decode: function (input, options) {
    let events = [],
      ccEvent;
    const xmlToJson = new XMLParser({
      stopNodes: ["*.p"],
      numberParseOptions: {
        skipLike: /[0-9]+/
      },
      ignoreAttributes: false
    });
    let jsonInput = xmlToJson.parse(input);
    let regions = JsonFind(jsonInput).findValues("region") || {
      region: []
    };
    let styles = JsonFind(jsonInput).findValues("style") || {
      style: []
    };
    let tt = JsonFind(jsonInput).findValues("tt") || {
      tt: {}
    };
    let useClockTime = tt.tt["@_ttp:timeBase"] && (tt.tt["@_ttp:timeBase"] === "clock" || tt.tt["@_ttp:timeBase"] === "media") ? true : false;
    if (!Array.isArray(regions.region)) {
      regions.region = [regions.region];
    }
    if (!Array.isArray(styles.style)) {
      styles.style = [styles.style];
    }
    let styleMap = convertStylestoStyleMap(styles.style);
    if (jsonInput.tt.body.div.p.length === undefined) {
      jsonInput.tt.body.div.p = [jsonInput.tt.body.div.p];
    }
    jsonInput.tt.body.div.p.forEach(paragraph => {
      ccEvent = new Event();
      ccEvent.start = tcLib.parseTcToSec(paragraph["@_begin"], options.frameRate, options.dropFrame, useClockTime);
      ccEvent.end = tcLib.parseTcToSec(paragraph["@_end"], options.frameRate, options.dropFrame, useClockTime);
      try {
        if (paragraph["#text"]) {
          let formattedText = ttmlFunc.multiLine.formatText(paragraph["#text"]).replace(/<br \/>|<br\/>|<br>/gim, "\n");
          ccEvent.text = convertToHtml(formattedText);
        }
      } catch (err) {
        ccEvent.text = convertToHtml(paragraph["#text"].replace(/<br \/>|<br\/>|<br>/gim, "\n"));
      }
      let positionMap = convertRegionsToPositionMap(regions.region, paragraph["@_tts:textAlign"]);
      if (paragraph["@_region"]) {
        ccEvent = {
          ...ccEvent,
          ...positionMap[paragraph["@_region"]]
        };
      } else {
        ccEvent.xPos = "center";
        ccEvent.yPos = "end";
        ccEvent.alignment = "center";
      }
      if (paragraph["@_tts:textAlign"] && alignments.includes(paragraph["@_tts:textAlign"])) {
        ccEvent.alignment = paragraph["@_tts:textAlign"];
      } else if (paragraph["textAlign"] && alignments.includes(paragraph["textAlign"])) {
        ccEvent.alignment = paragraph["textAlign"];
      } else if (paragraph["@_style"] && styleMap[paragraph["@_style"]] && styleMap[paragraph["@_style"]]["@_tts:textAlign"] && alignments.includes(styleMap[paragraph["@_style"]]["@_tts:textAlign"])) {
        ccEvent.alignment = styleMap[paragraph["@_style"]]["@_tts:textAlign"];
      }
      events.push(ccEvent);
    });

    // console.log(JSON.stringify(events, null, 2));

    return events;
  },
  encode: function (eventGroup, options) {
    let output = eol.after(`<?xml version="1.0" encoding="utf-8"?>`);
    output += eol.after(`<tt xmlns="http://www.w3.org/ns/ttml" xmlns:ttm="http://www.w3.org/ns/ttml#metadata" xmlns:tts="http://www.w3.org/ns/ttml#styling" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">`);
    output += eol.after(`<head>`);
    output += eol.after(`<metadata>
        <ttm:title>Untitled</ttm:title>
      </metadata>`);
    output += eol.after(`<styling>
        <style tts:fontStyle="normal" tts:fontWeight="normal" xml:id="s1" tts:color="white" tts:textOutline="black 2px 0px"  tts:fontFamily="Arial" tts:fontSize="80%"></style>
      </styling>`);
    output += eol.after(`<layout>
			<region tts:extent="80% 50%" tts:origin="10% 10%" tts:displayAlign="before" xml:id="topLeft" />
			<region tts:extent="80% 50%" tts:origin="10% 5%" tts:displayAlign="after" xml:id="centerLeft" />
			<region tts:extent="80% 50%" tts:origin="10% 40%" tts:displayAlign="after" xml:id="bottomLeft" />
			<region tts:extent="80% 50%" tts:origin="10% 10%" tts:displayAlign="before" xml:id="topCenter" />
			<region tts:extent="80% 50%" tts:origin="10% 5%" tts:displayAlign="after" xml:id="centerCenter" />
			<region tts:extent="80% 50%" tts:origin="10% 40%" tts:displayAlign="after" xml:id="bottomCenter" />
			<region tts:extent="80% 50%" tts:origin="10% 10%" tts:displayAlign="before" xml:id="topRight" />
			<region tts:extent="80% 50%" tts:origin="10% 5%" tts:displayAlign="after" xml:id="centerRight" />
			<region tts:extent="80% 50%" tts:origin="10% 40%" tts:displayAlign="after" xml:id="bottomRight" />
    </layout>`);
    output += eol.after(`</head>`);
    output += eol.after(`<body>`);
    output += eol.after(`<div style="s1" xml:id="d1">`);
    eventGroup.events.forEach((event, index) => {
      let id = index + 1;
      let plainTextCustom = convertToPlainTextCustom(event.text, "\n", false, "strong", "em", "u", true);
      let text = ttmlFunc.multiLine.convertToTtml(plainTextCustom);

      /* 3x3 Grid */
      let xRegion = flexbox.flexMap.horizontal[event.xPos];
      let yRegion = flexbox.flexMap.vertical[event.yPos];
      if (!xRegion) {
        xRegion = "center";
      }
      if (!yRegion) {
        if (event.yPos / options.window.height < 0.45) {
          yRegion = "top";
        } else if (event.yPos / options.window.height < 0.65) {
          yRegion = "center";
        } else {
          yRegion = "bottom";
        }
      }
      let region = yRegion + xRegion.charAt(0).toUpperCase() + xRegion.slice(1);
      output += eol.after(`<p xml:id="p${id}" begin="${event.startMsIncode.replace(",", ".")}" end="${event.endMsIncode.replace(",", ".")}" region="${region}" tts:textAlign="${xRegion}">${text}</p>`);
    });
    output += eol.after(`</div>`);
    output += eol.after(`</body>`);
    output += eol.after(`</tt>`);
    return output;
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input);
    }
  },
  postProcess: {
    encode: function (output) {
      return output;
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};